<template>
  <div class="inspection-task-map-container">
    <div id="inspectionTaskMap" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script>
import { queryInspectionTaskDetail } from '@/api/inspection/inspectionPointApi'
import { getCommunityId } from '@/api/community/communityApi'
import {
  DEFAULT_MAP_CENTER,
  addTiandituLabel,
  addTiandituMarker,
  addTiandituPolyline,
  clearTiandituMap,
  fitTiandituViewport,
  loadTiandituMapScript,
} from '@/utils/tiandituMap'

export default {
  name: 'InspectionTaskMap',
  data() {
    return {
      map: null,
      communityId: '',
      taskPoints: []
    }
  },
  mounted() {
    this.communityId = getCommunityId()
    // 延迟初始化地图，确保DOM已经渲染
  },
  methods: {
    async loadData(task) {
      const ready = await this.initMap()
      if (ready) {
        await this.loadTask(task)
      }
    },
    async initMap() {
      clearTiandituMap(this.map)
      this.map = null
      try {
        await loadTiandituMapScript()
        const center = new window.T.LngLat(DEFAULT_MAP_CENTER.lng, DEFAULT_MAP_CENTER.lat)
        this.map = new window.T.Map('inspectionTaskMap', {
          projection: 'EPSG:4326',
        })
        this.map.centerAndZoom(center, 13)
        return true
      } catch (error) {
        console.error('天地图加载失败:', error)
        this.$message.error(this.$t('tiandituMap.loadFailed'))
        return false
      }
    },

    async loadTask(task) {
      if (!task || !task.taskId) return

      try {
        const params = {
          communityId: this.communityId,
          taskId: task.taskId,
          page: 1,
          row: 1000
        }

        const response = await queryInspectionTaskDetail(params)
        this.taskPoints = response.data
        this.addPointsToMap(this.taskPoints)
      } catch (error) {
        console.error('获取任务点失败:', error)
        this.$message.error(this.$t('inspectionTaskMap.fetchError'))
      }
    },

    addPointsToMap(points) {
      if (!this.map || !points || points.length === 0) return

      clearTiandituMap(this.map)
      const path = []

      points.forEach(point => {
        if (!point.lat || !point.lng) return
        const completed = point.state === '20200405'
        const result = addTiandituMarker(this.map, point, {
          title: point.inspectionName,
          iconUrl: completed ? '/img/inspection_do.png' : '/img/inspection.png',
        })
        if (!result) return
        addTiandituLabel(
          this.map,
          result.lngLat,
          point.inspectionName,
          completed ? '#CC0000' : '#3777FF',
        )
        path.push(result.lngLat)
      })
      addTiandituPolyline(this.map, path)
      fitTiandituViewport(this.map, path)
    }
  },
  beforeDestroy() {
    clearTiandituMap(this.map)
    this.map = null
  }
}
</script>

<style scoped>
.inspection-task-map-container {
  width: 100%;
  height: 100%;
}
</style>
